// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"cb9daebf","164":"9acf9ead","254":"1cb992ad","301":"c31a8918","444":"61313bb8","453":"31a33fe4","721":"d672ae67"}[chunkId] + ".chunk.js";
};